import pluginsRepoMutations from "./mutations.js";
import pluginsRepoActions from "./actions.js";
import pluginsRepoGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            pluginsRepo: {},
            installedPlugins:[]
        };
    },
    mutations: pluginsRepoMutations,
    actions: pluginsRepoActions,
    getters: pluginsRepoGetters,
};